import { GroupingFactor } from "../ars_ldm";
import { isGroupingFactorDataDriven } from "./isGroupingFactorDataDriven";
import { isGroupingFactorWithGroups } from "./isGroupingFactorWithGroups";

/**
 * Type guard to check if a value is a GroupingFactor.
 *
 * Validates that the object is either a GroupingFactorDataDriven or a GroupingFactorWithGroups.
 *
 * @param obj - The value to check
 * @returns True if the value is a GroupingFactor
 */
export const isGroupingFactor = (obj: unknown): obj is GroupingFactor => {
  return isGroupingFactorDataDriven(obj) || isGroupingFactorWithGroups(obj);
};
